import environment from "@menu-environment";
import { RequestHelper } from "@lib-shared/lib";

class BaseService {
    protected baseUrl = "";

    abortController: AbortController | null = null;

    constructor(abortController: AbortController | null = null) {
        this.abortController = abortController;
    }

    protected setBaseUrl(path: string) {
        this.baseUrl = `${environment.menu.urls.menuConfig}/${path}`;
    }

    protected getRequestHelper(path: string | undefined) {
        const helper = new RequestHelper(this.baseUrl, this.abortController?.signal)
        return helper.withPath(path)
    }

    protected createPromiseRequest(path: string | undefined): RequestHelper {
        const helper = this.getRequestHelper(path);

        return helper.usingPromise();
    }
}

export default BaseService;